export enum Feature {
  Access3DModelEditorEnabled = 'ACCESS_3D_MODEL_EDITOR_ENABLED',
  DataProcessingToolEnabled = 'DATA_PROCESSING_TOOL_ENABLED',
  ManageDrillLabelsEnabled = 'MANAGE_DRILL_LABELS_ENABLED',
  UploadDataFilesEnabled = 'DATA_FILE_UPLOAD_ENABLED',
  WorldBuilder = 'WORLD_BUILDER',
  RasterColorMapping = 'RASTER_COLOR_MAPPING_ENABLED',
  UserPermissions = 'USER_PERMISSIONS',
  StandardizedFiles = 'COMPANY_STANDARDIZED_FILES',
  StandaloneFeatureProcessing = 'STANDALONE_FEATURE_PROCESSING_ENABLED',
  DoraV2Enabled = 'DORA_V2_ENABLED',
  AdminHomepageEnabled = 'ADMIN_HOMEPAGE_ENABLED',
  AccountLeadCompanySelfAssign = 'ACCOUNT_LEAD_COMPANY_SELF_ASSIGN',
}
